import { intakeHref } from '../lib/referral';
import React from 'react';
import { pricingItems } from '../mock';

export default function Pricing() {
  return (
    <section id="pricing" data-testid="pricing-section" className="scroll-mt-24 px-4 sm:px-6 py-16 sm:py-20 md:py-28">
      <div className="max-w-[1360px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-14">
        <div>
          <p className="eyebrow">Flat pricing</p>
          <h2 className="mt-5 sm:mt-6 font-display text-[32px] sm:text-[42px] md:text-[50px] leading-[1.06] tracking-[-0.025em] text-[color:var(--alfa-navy)] max-w-[600px]" data-testid="pricing-headline">
            Your dose may change.{' '}
            <span className="text-[color:var(--alfa-royal)]">Your monthly price stays the same.</span>
          </h2>

          <div className="mt-8 sm:mt-10 space-y-3">
            <p className="font-display text-[40px] sm:text-[54px] md:text-[64px] leading-none text-[color:var(--alfa-navy)]">
              <span className="text-[14.5px] sm:text-[16.5px] text-[color:var(--alfa-royal)] uppercase tracking-widest mr-3 align-middle">Semaglutide &mdash;</span>
              $169<span className="text-[16px] sm:text-[20px] text-[color:var(--alfa-ink)] ml-1">/month</span>
            </p>
            <p className="font-display text-[40px] sm:text-[54px] md:text-[64px] leading-none text-[color:var(--alfa-navy)]">
              <span className="text-[14.5px] sm:text-[16.5px] text-[color:var(--alfa-royal)] uppercase tracking-widest mr-3 align-middle">Tirzepatide &mdash;</span>
              $199<span className="text-[16px] sm:text-[20px] text-[color:var(--alfa-ink)] ml-1">/month</span>
            </p>
          </div>

          <p className="mt-6 sm:mt-8 text-[16px] leading-[1.6] text-[color:var(--alfa-ink)] max-w-lg">
            Know what you&rsquo;ll pay before you begin. Your monthly price doesn&rsquo;t increase as your prescribed dose increases within your selected medication.
          </p>
          <p className="mt-3 text-[13.5px] leading-[1.6] text-neutral-800 max-w-lg" data-testid="pricing-qualification">
            Flat monthly pricing applies across eligible prescribed doses within your selected medication. Switching medications changes your monthly price. Treatment is subject to clinical eligibility.
          </p>

          <a href={intakeHref()} target="_blank" rel="noopener noreferrer" data-testid="pricing-check-eligibility-btn" className="btn-primary arrow-suffix mt-7 sm:mt-8 inline-flex uppercase text-[14px] tracking-[0.14em] font-semibold px-5 sm:px-6 py-3.5 sm:py-4 rounded-sm">
            Check Eligibility
          </a>
          <p className="mt-3 text-[14px] font-semibold text-[color:var(--alfa-ink)]" data-testid="pricing-not-charged">Not approved? Not charged.</p>
          <p className="mt-1 text-[13px] text-neutral-700">A licensed clinician determines whether treatment is appropriate for you.</p>
        </div>

        <ul className="lg:pt-24 space-y-0">
          {pricingItems.map((item, i) => (
            <li key={item} className="flex items-center gap-4 sm:gap-6 py-4 sm:py-5 border-t border-neutral-900/15 last:border-b last:border-neutral-900/15">
              <span className="font-display text-[14.5px] sm:text-[16.5px] text-[color:var(--alfa-yellow)] tabular-nums w-6 sm:w-8">0{i + 1}</span>
              <span className="uppercase text-[13.5px] sm:text-[14.5px] tracking-[0.14em] sm:tracking-[0.15em] font-medium text-neutral-900">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
